<script>
import ModuleTitle from '../common/ModuleTitle.vue'
import CheckMoreText from '../common/CheckMoreText.vue'

import { getShadowColor, getPageThemeColor } from '@/utils/modules/getStyles'

export default {
  name: 'Comp14',
  components: { ModuleTitle, CheckMoreText },
  props: {
    moduleOption: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      path: this.$route.path
    }
  },
  methods: { getShadowColor, getPageThemeColor }
}
</script>

<template>
  <div class="modules-id-14">
    <module-title :title="moduleOption.title" margin-bottom="24" />
    <div class="comp-transverse-3 modules-id-14-content pointer">
      <div
        :style="{
          boxShadow: `0 3px 10px 0 ${getShadowColor(path)}`,
          backgroundColor: '#D56566'
        }"
        class="left-content"
      >
        <div class="img-group">
          <el-image
            v-for="v in moduleOption.list.slice(0, 4)"
            :key="`modules-14-${v.id}`"
            :src="v.photo | imgPath"
            alt="elegance"
            class="item-img"
            fit="cover"
          />
        </div>
        <check-more-text color="#fff" class="check-more-14" />
      </div>
      <div class="right-text"><p>离军不离党</p> <p>转业不转志</p></div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modules-id-14-content {
  height: 100%;
  display: flex;
}
.left-content {
  width: 380px;
  height: 325px;
  // border-radius: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-bottom: 6px solid #EDBC5A;
  .img-group {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    margin: 5px 0 0 5px;
    width: 370px;
    .item-img {
      width: 180px;
      height: 138px;
      border-radius: 5px;
    }
  }
}
.check-more-14 {
  margin-top: 6px;
}
.right-text {
  font-size: 23px;
  font-weight: 800;
  font-family: siyuansong;
  color: #D56566;
  letter-spacing: 2px;
  writing-mode: vertical-lr;
  height: 325px;
  display: flex;
  justify-content: space-between;
  padding: 24px 0;
  margin-left: 24px;
  box-sizing: border-box;
}
</style>
